import type { LucideIcon } from 'lucide-react'
import {
  CreditCard,
  Droplets,
  Gem,
  Leaf,
  ShieldCheck,
  Sparkles,
  Timer,
  Truck,
} from 'lucide-react'

export interface WhyChooseUsItem {
  id: string
  title: string
  description: string
  icon: LucideIcon
}

export const WHY_CHOOSE_US_ITEMS: WhyChooseUsItem[] = [
  {
    id: 'long-lasting',
    title: 'Long Lasting',
    description:
      'Concentrated attar oils that evolve on skin and stay with you from morning to evening.',
    icon: Timer,
  },
  {
    id: 'pure-oils',
    title: 'Pure Oils',
    description:
      'Premium-grade essential oils and attar bases — no fillers, no shortcuts.',
    icon: Droplets,
  },
  {
    id: 'alcohol-free',
    title: 'Alcohol Free',
    description:
      'Oil-based compositions gentle on skin and ideal for those who prefer alcohol-free scents.',
    icon: Leaf,
  },
  {
    id: 'hand-poured',
    title: 'Hand-Poured',
    description:
      'Small-batch pours with care, ensuring consistency and attention in every bottle.',
    icon: Gem,
  },
  {
    id: 'heritage-blends',
    title: 'Heritage Blends',
    description:
      'Classical oriental recipes refined for modern wearers who value authenticity.',
    icon: Sparkles,
  },
  {
    id: 'trusted-quality',
    title: 'Trusted Quality',
    description:
      'Transparent sourcing and rigorous checks — fragrance you can wear with confidence.',
    icon: ShieldCheck,
  },
  {
    id: 'cod-available',
    title: 'COD Available',
    description:
      'Cash on delivery on eligible orders — shop with flexibility and pay when your parcel arrives.',
    icon: Truck,
  },
  {
    id: 'secure-payment',
    title: 'Secure Online Payment',
    description:
      'Protected Razorpay checkout with UPI, cards, and net banking — safe and seamless every time.',
    icon: CreditCard,
  },
]

export const WHY_CHOOSE_US_AUTO_SLIDE_MS = 4500
